import { createContext } from 'react';
export const AuthenticationContext = createContext<AuthenticationContextValue>({
  authenticationData: null,
  isLoggedIn: false,
  setAuthenticationData: () => {},
  logout: () => {}
});
type IsLoggedInData = {
  authenticationData: AuthenticationData;
  isLoggedIn: true;
};
type IsNotLoggedInData = {
  authenticationData: null;
  isLoggedIn: false;
};
export type AuthenticationContextValue = (IsLoggedInData | IsNotLoggedInData) & {
  setAuthenticationData: (data: AuthenticationData | null) => void;
  logout: () => void;
};
export type AuthenticationData = {
  csrfToken: string;
  userId: string;
};